(function () {
  const NUMBER = "56976825434";
  const MESSAGE = "Hola Equipo TFP, necesito una cotización.";

  class TfpWa extends HTMLElement {
    connectedCallback() {
      if (this.shadowRoot) return;
      const n = this.getAttribute("number") || NUMBER;
      const m = this.getAttribute("message") || MESSAGE;
      const label = this.getAttribute("label") || "Cotizar por WhatsApp";
      const r = this.attachShadow({ mode: "open" });
      r.innerHTML = `
<style>
  :host { position: fixed; right: 28px; bottom: 28px; z-index: 80; }
  a {
    position: relative; display: flex; align-items: center; height: 58px;
    background: #1d1f20; border: 1px solid rgba(242,242,243,.18); color: #f2f2f3;
    text-decoration: none; overflow: hidden; box-shadow: 0 10px 32px rgba(0,0,0,.34);
    transition: background .4s cubic-bezier(.16,1,.3,1), border-color .4s ease;
  }
  a:hover, a:focus-visible { background: #a83f00; border-color: #a83f00; }
  a:focus-visible { outline: 2px solid #f2f2f3; outline-offset: 2px; }
  a:active { background: #8c3400; }
  i { position: absolute; background: rgba(242,242,243,.5); }
  i.h { width: 7px; height: 1px; }
  i.v { width: 1px; height: 7px; }
  i.tl { top: 5px; left: 5px; }
  i.br { bottom: 5px; right: 5px; }
  .ico { width: 58px; height: 58px; flex: 0 0 58px; display: flex; align-items: center; justify-content: center; }
  .txt {
    max-width: 0; opacity: 0; white-space: nowrap; padding: 0;
    font-family: 'Barlow Condensed', system-ui, sans-serif; font-size: 13px;
    letter-spacing: .2em; text-transform: uppercase;
    transition: max-width .5s cubic-bezier(.16,1,.3,1), opacity .35s ease, padding .5s cubic-bezier(.16,1,.3,1);
  }
  a:hover .txt, a:focus-visible .txt { max-width: 280px; opacity: 1; padding: 0 24px 0 2px; }
  @media (max-width: 640px) { :host { right: 18px; bottom: 18px; } }
</style>
<a href="https://wa.me/${n}?text=${encodeURIComponent(m)}" target="_blank" rel="noopener" aria-label="${label}">
  <i class="h tl"></i><i class="v tl"></i><i class="h br"></i><i class="v br"></i>
  <span class="ico">
    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path><path d="M9.4 8.4c.2-.5.4-.5.6-.5h.5c.2 0 .4 0 .6.4l.7 1.7c.1.2 0 .4-.1.5l-.4.5c-.1.2-.2.3-.1.5a5.2 5.2 0 0 0 2.4 2.4c.2.1.4 0 .5-.1l.5-.5c.1-.1.3-.2.5-.1l1.6.8c.3.2.4.3.4.5v.5c0 .3-.2.6-.6.9a2.4 2.4 0 0 1-1.4.5c-1 0-2.4-.6-3.9-2.1s-2.1-2.9-2.1-3.9c0-.5.2-1 .5-1.4l-.2-.6z"></path></svg>
  </span>
  <span class="txt">${label}</span>
</a>`;
    }
  }
  if (!customElements.get("tfp-wa")) customElements.define("tfp-wa", TfpWa);
})();
